import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';

bus.on(constants.EVENTS.APP.READY, () => {
  try {
    const isAndroidApp = false;
    const store = getStore('shared');
    store.state.isAndroidApp = isAndroidApp;
  } catch (error) {}

  try {
    setTimeout(() => {
      document.querySelector('#splash').style.display = 'none';
    }, 1500);
  } catch (error) {}
});

bus.on(constants.EVENTS.SHARED.RELOAD_APP_TO_HOME, () => {
  document.querySelector('#splash').style.display = 'flex';
  setTimeout(() => {
    window.location.href = '/';
  }, 1000);
});

bus.on(constants.EVENTS.SHARED.RELOAD_APP, () => {
  document.querySelector('#splash').style.display = 'flex';
  setTimeout(() => {
    window.location.reload();
  }, 1000);
});
